document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('.form-container');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
  input[type=text], input[type=email], input[type=tel], input[type=password], .input, select, button[class^='_selectToggle'], button[class*=' _selectToggle'], textarea[class^='_textArea'],textarea[class*=' _textArea'] {
      font-family: 'GT Walsheim';
        position: relative;
        display: inline-block;
        cursor: pointer;
        -webkit-appearance: none;
        appearance: none;
        border-radius: 9999px;
        padding: .75rem 1rem;
        font-size: 1em;
        line-height: 1.3;
        box-shadow: inset 0 0 0 2px var(--body-text-color);
        box-sizing: border-box;
        color: var(--body-text-color);
    }
  
  `);
  sheet.insertRule (`
    
    form label, p[class^="_label"], p[class*=" _label"] {
      font-family: 'GT Walsheim' !important;
      font-size: .9rem !important;
      top: 25px !important;
      left: 0 !important;
      line-height: 1.3 !important;
      color: var(--body-text-color) !important;
      transform: none !important;
    }
    
  `
  )
   sheet.insertRule (`
    
   p[class^="_label"], p[class*=" _label"] {
      margin-top: 25px;
      margin-bottom: 6px;
    }
  `
  )
  sheet.insertRule (`
    textarea[class^='_textArea'], textarea[class*=' _textArea'] {
      border-radius: 1rem !important;
    }
  `
  )
  sheet.insertRule (`
    section[class^='_formContainer'], section[class*=' _formContainer']{
      max-width: 42rem !important;
      padding-right: 2.5rem !important;
      padding-left: 2.5rem !important;
      box-sizing: border-box;
    }
  `)
  sheet.insertRule (`
    div[class^='_formFieldContainer'], div[class*='_formFieldContainer']{
      padding-top: 57px;
    }
  `)
  sheet.insertRule (`
    div[class^='_formPhoneInputContainer'], div[class*='_formPhoneInputContainer']{
      align-items: flex-end;
    }
  `)
  sheet.insertRule (`
    button[class^='_selectToggle'], button[class*='_selectToggle']{
      max-height: 59px !important;
    }
  `)
  sheet.insertRule (`
    button[class^='_selectToggle'] span, button[class*='_selectToggle'] span{
  color: var(--body-text-color);
    }
  `)
    sheet.insertRule (`
    button[class^='_formSubmitButton'], button[class*='_formSubmitButton']{
        border-radius: 9999px;
    padding: .75rem 1rem;
    text-align: center;
    font-size: 1rem;
    line-height: 1.3;
    text-transform: none;
    box-shadow: inset 0 0 0 2px var(--button-background-color);
    box-sizing: border-box;
    transition: transform .1s cubic-bezier(.215,.61,.355,1);
    font-weight: 400;
    position: relative;
    box-sizing: border-box;
    }
  `)
  sheet.insertRule (`
  button[class^='_formSubmitButton']:after, button[class*='_formSubmitButton']:after{
    content: "";
    position: absolute;
    top: 6px;
    left: 6px;
    height: 100%;
    width: 100%;
    border-radius: 9999px;
    display: block;
    background-color: rgb(transparent);
    background-image: transparent;
    border-width: 2px;
    border-color: var(--button-background-color);
    z-index: -1;
    border-style: solid;
    box-sizing: border-box;
        transition: transform .1s cubic-bezier(.215,.61,.355,1);
    }
  `)
   sheet.insertRule (`
  button[class^='_formSubmitButton']:hover, button[class*='_formSubmitButton']:hover{
   transform:translate(6px, 6px);
    }
  `)
  sheet.insertRule (`
  button[class^='_formSubmitButton']:hover:after, button[class*='_formSubmitButton']:hover:after{
   transform:translate(-6px, -6px);
    }
  `)
  sheet.insertRule (`
span[class^='_selectToggleText'], span[class*='_selectToggleText']{
   vertical-align: middle;
    }
  `)
  sheet.insertRule (`
  h2[class^='_textHeading'],h2[class*=' _textHeading'], h2[class^='_formBannerHeading'],h2[class*=' _formBannerHeading'] {
   font-size: 1.7em !important;
   font-family: Young Serif !important;
   color: var(--heading-text-color) !important;
   line-height: 1.3 !important;
    }
  `)
  sheet.insertRule (`
  div[class^='_textBody'] p ,div[class*=' _textBody'] p{
   font-family: 'GT Walsheim';
   color: var(--heading-text-color);
   font-size: 1rem;
   line-height: 1.3;
    }
  `)
  sheet.insertRule (`
  div[class^='_dropdownContainer'],div[class*=' _dropdownContainer']{
   overflow: scroll;
    }
  `)
  sheet.insertRule (`
  div[class^='_formPhoneInputContainer'] div[class^='_formFieldContainer'], div[class*='_formPhoneInputContainer'] div[class^='_formFieldContainer'],div[class^='_formPhoneInputContainer'] div[class*=' _formFieldContainer'], div[class*='_formPhoneInputContainer'] div[class*=' _formFieldContainer']{
   position: static;
    }
  `)
    sheet.insertRule (`
  label[class^='_inputFilled'],label[class*=' _inputFilled']{
   transform: none !important;
    }
  `)
  sheet.insertRule (`
  @media(max-width: 500px){
    div[class^='_formPhoneInputContainer'] span[class^='_selectToggle'], div[class*='_formPhoneInputContainer'] span[class^='_selectToggle'],div[class^='_formPhoneInputContainer'] span[class*=' _selectToggle'], div[class*='_formPhoneInputContainer'] span[class*=' _selectToggle']{
         width: calc(100% - 9px);
    }
  }
  `)
  sheet.insertRule (`
  @media(max-width: 500px){
    div[class^='_formPhoneInputContainer'] button[class^='_selectToggle'], div[class*='_formPhoneInputContainer'] button[class^='_selectToggle'],div[class^='_formPhoneInputContainer'] button[class*=' _selectToggle'], div[class*='_formPhoneInputContainer'] button[class*=' _selectToggle']{
         padding: .75rem 10px;
    }
  }
  `)

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});